<script lang="ts">
	import { page } from '$app/stores';
	import { lazyLoad } from '$lib/actions/lazyLoad';
	import arrowRightDark from '$lib/assets/images/icons/arrow-right-dark.svg';
	import __ from '$lib/stores/TranslationStore';

	export let image: string;
	export let category: string;
	export let title: string;
	export let text: string;
	export let link: string;
</script>

<div class="relative h-full rounded-lg bg-light p-8 pb-28 text-dark">
	<img use:lazyLoad={image} alt={title} class="mx-auto aspect-[3/2] w-full" loading="lazy" />

	<h4 class="mt-5 text-center text-sm font-semibold uppercase leading-10 tracking-widest text-dark">
		{category}
	</h4>
	<h4 class="my-5 text-center text-3xl font-bold">{title}</h4>
	<hr class="border-1.8 border-secondary" />
	<p class="mt-5 px-3 text-lg leading-6">
		{text}
	</p>
	<a
		href={$page.data?.location?.origin + link}
		class="absolute bottom-8 left-0 flex w-full items-center justify-center gap-4 text-sm font-bold uppercase tracking-widest"
	>
		{$__('Saiba mais')}

		<img use:lazyLoad={arrowRightDark} alt="Ir para {category}" class="h-6 w-6" loading="lazy" />
	</a>
</div>
